module.exports = __webpack_public_path__ + "img/light-switch-lg.4eb7d31f.svg";